export enum Views {
  'otp_email',
  'otp_code',
  'classic',
  'forgot_password',
  'forgot_password_confirmed',
}

export const title = {
  [Views.otp_email]: 'Log In to Worthy',
  [Views.otp_code]: 'Log In to Worthy',
  [Views.classic]: 'Log In to Worthy',
  [Views.forgot_password]: 'Forgot password',
  [Views.forgot_password_confirmed]: 'Forgot password',
};

export const text = {
  [Views.otp_email]: 'Enter your email and we’ll send you a temporary 4 digit login code',
  [Views.otp_code]: 'Enter the 4 digit code sent to:',
  [Views.classic]: 'Enter your email and password',
  [Views.forgot_password]:
    'Please enter your email address below and password reset instructions will be sent to you.',
  [Views.forgot_password_confirmed]:
    'If the email {{email}} exists in our records, a password reset mail has been sent to it.',
};

export const actionPrimary = {
  [Views.otp_email]: 'Send code to my email',
  [Views.otp_code]: 'Log in',
  [Views.classic]: 'Log in',
  [Views.forgot_password]: 'Submit',
  [Views.forgot_password_confirmed]: '',
};

export const actionSecondary = {
  [Views.otp_email]: 'Send code to my phone',
  [Views.otp_code]: 'Resend code',
  [Views.classic]: 'Forgot your password?',
  [Views.forgot_password]: '',
  [Views.forgot_password_confirmed]: '',
};

export const inputPrimary = {
  [Views.otp_email]: {
    label: 'Email',
    autoComplete: 'email',
    key: `email-${Views.otp_email}`,
    name: 'email',
  },
  [Views.otp_code]: null,
  [Views.classic]: {
    label: 'Email',
    autoComplete: 'email',
    key: `email-${Views.classic}`,
    name: 'email',
  },
  [Views.forgot_password]: {
    label: 'Email',
    autoComplete: 'email',
    key: `email-${Views.forgot_password}`,
    name: 'email',
  },
  [Views.forgot_password_confirmed]: null,
};

export const inputSecondary = {
  [Views.otp_email]: null,
  [Views.otp_code]: null,
  [Views.classic]: {
    label: 'Password',
    autoComplete: 'password',
    key: `password-${Views.classic}`,
    name: 'password',
    type: 'password',
  },
  [Views.forgot_password]: null,
  [Views.forgot_password_confirmed]: null,
};

export const otpInput = {
  placeholder: '',
  autoComplete: 'off',
  inputMode: 'numeric',
  pattern: '[0-9]',
} as const;

export const registrationLink = `${process.env.REACT_APP_MONOLITH_URL}/buyers/registration_form`;

export const assistancePhone = `tel:+18889210415`;
export const assistancePhoneLabel = `1 (888) 921-0415`;

export const initialCredentials = {
  email: '',
  password: '',
  code: ['', '', '', ''],
};

export const initialErrors = {
  errorPrimary: '',
  errorSecondary: '',
};
